<section class="content" *ngIf="(profileState | async).followerEngage !== null">
  <h6 class="content-header">Key metrics</h6>
  <div class="row" [ngClass]="!(profileState | async).loader['audit']['followerEngage'] ? 'background-loader' : ''">
    <div class="spinner" *ngIf="!(profileState | async).loader['audit']['followerEngage']"></div>
    <div class="col-6 col-md-3">
      <div class="card">
        <div class="card-body">
          <div class="flex flex-wrap">
            <div class="result-icon-box">
              <img class="result-icon" src="./assets/images/icons/eye.png"/>
            </div>
            <div class="report-results mt-0">
              <div class="b-left">
                <div class="text-left">
                  <h2>{{(profileState | async).followerEngage.reach_sum | shortcutNumbers}}</h2>
                  <p class="sub-text">Total views</p>
                </div>
                <div class="text-left mt-3">
                  <h2>{{(profileState | async).followerEngage.reach_rate}}%</h2>
                  <p class="sub-text">Views rate</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-6 col-md-3">
      <div class="card">
        <div class="card-body">
          <div class="flex flex-wrap">
            <img class="result-icon" src="./assets/images/icons/heart-2.png"/>
            <div class="report-results mt-0">
              <div class="b-left">
                <div class="text-left">
                  <h2>{{(profileState | async).followerEngage.like_sum | shortcutNumbers}}</h2>
                  <p class="sub-text">Total likes</p>
                </div>
                <div class="text-left mt-3">
                  <h2>{{(profileState | async).followerEngage.like_rate}}%</h2>
                  <p class="sub-text">Like rate</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-6 col-md-3">
    <div class="card">
      <div class="card-body">
        <div class="flex flex-wrap">
          <img class="result-icon" src="./assets/images/icons/chat.png"/>
          <div class="report-results mt-0">
            <div class="b-left">
              <div class="text-left">
                <h2>{{(profileState | async).followerEngage.comment_sum | shortcutNumbers}}</h2>
                <p class="sub-text">Total comments</p>
              </div>
              <div class="text-left mt-3">
                <h2>{{(profileState | async).followerEngage.comment_rate}}%</h2>
                <p class="sub-text">Comments rate</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
    <div class="col-6 col-md-3">
      <div class="card">
        <div class="card-body">
          <div class="flex flex-wrap">
            <img class="result-icon" src="./assets/images/icons/share.png"/>
            <div class="report-results mt-0">
              <div class="b-left">
                <div class="text-left">
                  <h2>{{(profileState | async).followerEngage.share_sum}}</h2>
                  <p class="sub-text">Total shares</p>
                </div>
                <div class="text-left mt-3">
                  <h2>{{(profileState | async).followerEngage.share_rate}}%</h2>
                  <p class="sub-text">Shares rate</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
